import { Record } from 'immutable'

export class ServiceWorker extends Record({
    id: undefined,
    first_name: undefined,
    last_name: undefined,
    email: undefined,
    costs: undefined,
}) {}
